/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {saveAs} from 'file-saver'
import FromToPicker from '../BaseComponent/FromToPicker'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import Select from 'react-select'
import http from '../Interceptor/Interseptor'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import AutoComplete from '../BaseComponent/autocomplete'

class ReportRemainProvider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      fromDate: '',
      toDate: '',
      providers: [],
      providerId: ''
    }
  }

  componentDidMount() {}

  submit(e) {
    e.preventDefault()
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getPDF() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let providerId = this.state.providerId ? this.state.providerId : ''

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/supplier/orders/products/general?fromTime=${minDate}&toTime=${maxDate}&providerId=${providerId}`
      )
    }
  }
  getPDFDriver() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let providerId = this.state.providerId ? this.state.providerId : ''

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/supplier/orders/products/drivers?fromTime=${minDate}&toTime=${maxDate}&providerId=${providerId}`
      )
    }
  }

  getProductPDF() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let providerId = this.state.providerId ? this.state.providerId : ''

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/supplier/orders/drivers/products?fromTime=${minDate}&toTime=${maxDate}&providerId=${providerId}`
      )
    }
  }

  driverProduct() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let providerId = this.state.providerId ? this.state.providerId : ''

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/driver/supplier/products?fromTime=${minDate}&toTime=${maxDate}&providerId=${providerId}`
      )
    }
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(JSON.stringify(selectedOption))
    console.log(`Option selected:`, selectedOption)
  }

  providerMali() {
    let providerId = this.state.providerId ? this.state.providerId : ''

    let minDate = this.state.fromDate
    let maxDate = this.state.toDate

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      JASPERREPORT(
        `report/jasper/supplier/orders/products/discount?fromTime=${minDate}&toTime=${maxDate}&providerId=${providerId}`
      )
    }
  }

  chap() {
    let providerId = this.state.providerId ? this.state.providerId : ''

    let minDate = this.state.fromDate
    let maxDate = this.state.toDate

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else if (providerId === '') {
      message.error('تامین کننده انتخاب شود')
    } else {
      JASPERREPORT(
        `report/jasper/supplier/orders/aggregated-detailed?fromTime=${minDate}&toTime=${maxDate}&providerId=${providerId}`
      )
    }
  }

  getResid = () => {
    let providerId = this.state.providerId ? this.state.providerId : ''

    let minDate = this.state.fromDate
    let maxDate = this.state.toDate

    if (minDate == '' || maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else if (providerId === '') {
      message.error('تامین کننده انتخاب شود')
    } else {
      JASPERREPORT(
        `report/jasper/supplier/orders/products/general/providers/${providerId}?fromTime=${minDate}&toTime=${maxDate}`
      )
    }
  }

  disabledResidButton = () => {
    const {fromDate, toDate} = this.state

    if (!this.state.providerId) return true
    if (!fromDate || !toDate) return true
    if (isNaN(fromDate) || isNaN(toDate)) return true
    else {
      const minDate = new Date(fromDate)
      const maxDate = new Date(toDate)
      minDate.setDate(minDate.getDate() + 1)
      return minDate < maxDate
    }
    // return false;
  }

  render() {
    let {selectedOption} = this.state

    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>گزارش کالای تامین کننده</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش کالای تامین کننده</p>
            </div>
            <FromToPicker
              onChangeFromDate={this.handleChangeFromDate}
              onChangeToDate={this.handleChangeToDate}
              fromLabel="از تاریخ تحویل انبار"
              toLabel="تا تاریخ تحویل انبار"
              force={true}
              defaulValue={true}
              fromId="from"
              toId="to"
            />

            <div className="formComponent selectComponent">
              <AutoComplete
                label="تامین کننده"
                api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                textField="title"
                valueField="providerId"
                id="provider"
                value={this.state.providerId}
                setValue={(providerId) => this.setState({providerId})}
              />
            </div>
            <div className="formComponent">
              <button
                className="btn btn-info btn-block jasperBtn"
                onClick={this.getResid.bind(this)}
                disabled={this.disabledResidButton()}
              >
                {' '}
                رسید راننده
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getPDF.bind(this)}>
                {' '}
                دریافت گزارش کالای تامین کننده
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getPDFDriver.bind(this)}>
                {' '}
                دریافت گزارش کالای تامین کننده به تفکیک کالا - رساننده
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getProductPDF.bind(this)}>
                {' '}
                دریافت گزارش کالای تامین کننده به تفکیک رساننده - کالا
              </button>

              <button className="btn btn-info btn-block jasperBtn" onClick={this.driverProduct.bind(this)}>
                {' '}
                لیست کالا های رساننده به تفکیک تامین کننده
              </button>

              <button className="btn btn-info btn-block jasperBtn" onClick={this.providerMali.bind(this)}>
                {' '}
                گزارش ریز کالای تامین کننده - واحد مالی
              </button>
              <button className="btn btn-info btn-block jasperBtn" onClick={this.chap.bind(this)}>
                چاپ
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default ReportRemainProvider
